module.exports = __webpack_public_path__ + "img/winerack43.929166c7.jpg";